import script from "./ChirpPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChirpPage.vue?vue&type=script&setup=true&lang=js"

import "./ChirpPage.vue?vue&type=style&index=0&id=18c35706&lang=css"

const __exports__ = script;

export default __exports__